<ion-grid class="ion-no-padding">
	<ion-row>
		<ion-col size="8">
			<ion-buttons>
				<ion-button class="ion-no-padding">
					<ion-icon class="icon-Search"></ion-icon>
				</ion-button>
			</ion-buttons>
		</ion-col>
		<ion-col size="4">
			<ion-buttons>
				<ion-button class="ion-no-padding">
					<ion-icon class="icon-Sort"></ion-icon>
				</ion-button>
				<ion-button class="ion-no-padding">
					<ion-icon class="icon-Filter"></ion-icon>
				</ion-button>
			</ion-buttons>
		</ion-col>
	</ion-row>
</ion-grid>
